module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "section_chapter--num_2--seq_9"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  })]), _c('div', {
    staticClass: "title-block"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674920_toc"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THOSE")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("DAYS")]), _vm._v(" the Golden Arrow still had some style, but we didn’t realise it. Indeed, quite the reverse. All the way to Dover we sighed for the lost graces of pre-war Europe. Were we unfashion-able young men? I can’t say. I am inclined to think we must have been, for I have never felt in tune with my generation. Perhaps that is why I drift round Geneva like a stateless person.")]), _c('p', [_vm._v("The engine hissed steam, and when I look back now, I see Victoria Station like an old black-and-white movie. We had porters, two of them for three undergraduates. It would be only a few years before denim became the uniform of a student generation, but all three of us wore suits. Did we travel first-class? We may well have done.")]), _c('p', [_vm._v("We aspired to nonchalance, as the approved mode in which to face life, but only Jamie Fernie at that moment achieved it. His father was on the staff of SHAEF and he had made this journey in the last two vacations, but both Eddie Scrope-Smith and I were lively with excitement. Eddie was nineteen and it was his first time out of England, and as for me I had not been in France since we decamped in 1939.")]), _c('p', [_vm._v("‘Do you know what Wilkie Collins said to Dickens?’ Eddie asked. And without waiting to hear if we did, said, ‘“The morality of England is firmly based on the immorality of Paris.” I must say, I do hope so,’ and he rolled mischievous dark eyes and pushed a lock of hair off his left eye.")]), _c('p', [_vm._v("Jamie busied himself giving instructions to the porters. Our luggage was at last stowed aboard, and we settled ourselves in a carriage.")]), _c('p', [_vm._v("‘Do you think we should have some champagne?’ Eddie asked.")]), _c('p', [_vm._v("‘I wish you weren’t always so flash, Eddie,’ Jamie said.")]), _c('p', [_vm._v("‘Me flash? I’m a perfect beau.’")]), _c('p', [_vm._v("When Eddie used that word, which had become one of his favourites that summer term, he recalled not only the Regency, in which he delighted, but also the fiction of the Old South, and Tennessee Williams’ plays, the first of which had been staged in "), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("London. They enthralled him, and for several weeks the long vowels of the South invaded his speech.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("The conversation of undergraduates can hardly seem other than banal in recollection. It may also appear impenetrable. So much of our talk was based on jokes that depended on secret allusions. You can find the same sort of thing in Byron’s correspondence, and it requires footnotes to elucidate the meaning. But in our case the passage of time has effaced even the content of our talk, let alone its form. I cannot remember another word of that journey, and yet, as I sit in my hotel room, its mood enfolds me, sweet and momentary as evening honeysuckle in the summer garden.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("We were all at the point of splendid and irresponsible possibility, when life seems a toy, fluid as mercury, malleable as plasticine. We could be whatever we chose, and what we chose first was to be in love, with ourselves, with each other, with existence and the immediate moment which we enriched by our absorption in a wholly, or almost completely, imaginary past. Our love was tender, nervous and evanescent; it survives as the most distant and faint of woodland melodies. This is why it is possible to gaze back on youth with longing, even while particular instances may remind us that in those days we were just as ready to weep and despair as to laugh and rejoice. All our emotions were merely garments in which the whim of a moment clothed us, and we shed them as easily as we hopped into a bath before preening in front of the glass in a new suit.")])]), _c('div', {
    staticClass: "block stanza"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_c('em', [_vm._v("Quand il me prend dans ses bras "), _c('br')]), _c('em', [_vm._v("Alors je sens en moi "), _c('br'), _vm._v("Mon coeur qui bat … ")])])])]), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_c('em', [_vm._v("La Vie en Rose")]), _vm._v(" is the tune that sighs through those first days in Paris. And yet I cannot even remember where Jamie’s parents had their apartment. He was nervous before we met them, and they seemed an ill-matched pair. His father gave a good performance as the professional soldier, so good that I had no notion it was a performance. Eddie was more alert: ‘the Poona Pathan’, he called him. But I didn’t see beyond the caustic teasing which he adopted towards Eddie; I saw only the Colonel. As for his mother, there I felt myself on firmer ground. Mrs Fernie looked like an exceedingly well-bred horse, and this struck me as quite suitable because I knew she had some reputation as a novelist. It’s gone now of course, and when out of curiosity I got a couple of her novels from the London Library, they gave off an authentic, yet dead, smell of ")]), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("the forties. Her talent, I realised, lay in her ability to write like Elizabeth Bowen, so like Elizabeth Bowen that you were first surprised, checking back on the book’s spine, to see the name Laura Maudsley there. But that’s all there was, this echo of a stronger writer. Yet with what admiration, amounting even to reverence on the part of some, her books were received then. She doted on Jamie. He was her only child, and she saw him both as an ally in the cold war she conducted with Colonel Fernie, and as someone who had to be protected from her husband’s values; yet these were precisely the civilised standards she upheld in her writing, and in truth he embodied them in action far better than she did. All marriages have something of mystery in them to outsiders.")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Terribly Oedipal, isn’t it,’ Eddie said, lolling on my bed wrapped in a huge deep-piled yellow bath towel, and admiring his reflection in the glass. ‘No wonder Jamie acts cold. As for the Colonel, it’s a case of “he loves me,” – he puffed out his lips and blew a kiss – “he loves me not.”’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘How vain you are. You think every Colonel loves you.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Well I do see I am rather a Colonel’s boy. I expect my National Service to be scrumptious.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Oh shut up,’ I said, and threw a pillow at him.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Don’t fancy this dinner tonight,’ he said. ‘My lousy Frog will be revealed. It’s all right for you, ducky, speaking Frog like a native.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Don’t let Cyril Connolly hear you call the language Frog.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Why not? My mama tells me his own Frog is something dreadful.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("I began to shave.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘I think I’ll tell the Colonel my own papa was the wrong sort of CO. That might choke him off. He won’t get it at first probably, like Hannay when he is just about to ask Mary’s aunts what regiment Lancelot Wake commanded, and then remembers what, in their language, the initials stand for. But if he says, “And what did your dad do in the war, young fellow?” what do I tell him? You must see my dilemma. He might after all find it exciting to think I am a conchy’s son. Perhaps’ – he examined his fingernails – ‘perhaps I’ll just say he was in the RASC. Nobody could find the RASC sexy, could they?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘So you want to choke him off then, do you?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Oh, I think so, I ever so truly and really and sincerely think so.’")])]), _c('div', {
    staticClass: "paras decoration"
  }, [_c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("*")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘And what did your dad do in the war, young fellow?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("I had been embarrassed to find myself alone in the drawing room with Colonel Fernie, whom I had surprised mixing a Martini. He hesitated, uncertain whether he should offer me one, and posed this question instead.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("I looked round the gilt and heavy mahogany furniture of the Second Empire room and said,")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘He was killed, sir.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Oh,’ he said, ‘rotten luck for you. And your Ma lives in South Africa, Jamie tells me.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘That’s right, sir. She married a South African pilot, and we went out there after the war.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Marvellous country. We called in there on our way to the desert in ’42, and I went down with fever and spent three months convalescing. Marvellous country, I thought, and a great future. To tell you the truth I’ve thought of settling there myself some time, but Laura wouldn’t like it. She’s very cultured, moves in a narrow triangle.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("He jerked his head backward, so that it passed into the shadow of the table lamp beside which he had been mixing his drink, and the movement, of which he was probably quite unconscious himself, suggested a rejection of his wife’s standards, even a revulsion from them.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Martini?’ he now said, perhaps concluding that my assurance of a dead father and a mother domiciled in remote, if marvellous, South Africa made it proper for him to offer me one.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘I warn you,’ he said, ‘I make them strong. What our American friends irreverently and unfairly call Montgomeries, thirteen parts of gin to one of vermouth, that is. The Field-Marshal’s teetotal himself of course, which makes the description irreverent, and though he was reluctant to engage in battle till the odds were in his favour, he didn’t demand that sort of superiority, which makes it unfair. In fact, it’s practically unattainable in war, and when it comes to superiority in material, well, I have to say that our American friends can give points to anyone. They’ve never in the history of American conflict fought a battle where they suffered material inferiority, not since Robert E. Lee handed over his sword to General Grant. Laura doesn’t like me talking of military matters, no more does Jamie. Do you know what a soldier is, young man? He’s the chap who makes it possible for civilised folk to despise war.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("I sipped my Martini. It was certainly strong, though it might have surprised him to learn that Jamie made them even stronger. ")]), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("The Colonel downed his, and poured another from the shaker.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Sorry about your dad,’ he said. ‘I won’t ask you about it, because I’ve learned it doesn’t always do to nose into these matters, here in France. There’s a very natural sensitivity. I don’t know your politics either, or your family’s. But just remember this. In a civil war, and it was just that in France, there is always right on both sides. And a soldier has to obey orders, which – some folk forget – in 1940 emanated from the Marshal, emanated lawfully. His trial stank. Was your dad a professional soldier?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘No, sir. His father was. He was killed at Verdun. He was a regular Army officer and, I believe, was convinced till the day of his death that Dreyfus had been guilty. That sort of professional soldier.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘We hardly have that sort in England – not that I’m English – my family’s Scots, but on my mother’s side we’re Ulstermen, and that’s the nearest to a military caste we have produced. Don’t know if you’re interested in these things. I am. Jamie tells me he wants to go into the Diplomatic. His mother’s idea. Talk him out of it, if you get the chance, old man. No life for a chap, just a career.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("He inclined the shaker towards me.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Jolly good Martini, sir.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Glad you like it. Sure you should be drinking it, are you? My Dad forbade me spirits till I was twenty-five, but when I came out of Sandhurst, my first Colonel said he wasn’t going to have an officer in his mess who wouldn’t down a glass of brandy in the evening. He’d spent his early service in the Indian Army, you see. I suppose, with a French father, your own French is pretty good, eh?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Well, my first language, sir.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘And you’ve kept it up? Good. I spoke nothing but Hindustani till I was five. Or so they tell me. Can’t put ten words together in the language now. Always regretted it. But at least that means that this evening won’t be a trial to you linguistically. We’ll only be 50 per cent French at dinner, but Laura likes general conversation to be conducted in French. Out of courtesy, she says. God knows what she’d demand if I was posted to Constantinople.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘You might not invite Turks to dinner, sir.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Hadn’t thought of that. You may be right. Are there any Turk novelists? What’s Jamie’s French like?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Good enough for the Diplomatic, sir, I’m afraid.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘Hell’s bells, all grammar and no idiom, eh? The only way to ")]), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("learn a language after you’re a child is to get yourself a mistress, a girl from the streets, or what they call here the "), _c('i', [_vm._v("demi-monde")]), _vm._v(". A little milliner. That’s what Puggsy Baker used to say. Wouldn’t know myself.’ He laid his finger along the side of his nose. ‘My own French is wooden.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("In fact, it was more fluent, and far more racy, than his wife’s. But the Colonel, as I began to see, was more than a bit of an actor.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘This shaker’s getting dull. We’d better liven it up,’ he said. ‘Glad you came down early. A man ought to get to know his son’s friends. It’s probably the nearest he can come to knowing his son.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("And he smiled, looking like Mr Punch.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘All fathers worry about their sons, I suppose,’ he said. ‘That they can’t talk to them. That they will grow up not to resemble them, that they will grow up to do so. Either prospect seems alarming, if we are honest. But it’s hard to be honest about family affairs.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("As he spoke I saw how absurd Eddie’s fantasies were; how, even more than I, he lived in a world of make-believe. We were still in the nursery, playing at grown-ups.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘But of course, you know what sons want to do,’ the Colonel said. ‘There’s a German proverb I believe: “Happy as the boy who killed his father”. Sums up a lot, I’ve always thought. I hear the bell. Gird up your French, oil your idioms.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("And, very quickly, to assist me, he tipped the cocktail shaker in the direction of my glass.")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("I soon saw that Jamie was sulking. He had been placed opposite me, at a slight angle, between two Frenchwomen, one blonde and statuesque, as if she had risen from a marble plinth in the Louvre where she had been reclining since Canova gave her form, and the other slim, dark, bread-crumbling, and quicker to lift her glass of champagne than her fork. It was clear that Jamie’s diplomatic French wasn’t up to dinner-table conversation. As for Eddie, his lousy Frog was proving no handicap, though it was a plump yellowish man sitting opposite him in a ruffled shirt, looking as far as features went in fact extremely like a frog, who had engaged him in conversation, rather than either of the unremarkable ladies who flanked him. I could see Eddie sparkle, as he did when people chaffed him, and three or four times the yellowish frog broke out in laughter. There wasn’t in fact much laughter at the table, and this made Eddie’s success all the more remarkable.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("The champagne and the "), _c('em', [_vm._v("foie gras ")]), _vm._v("were succeeded by a fish and some white burgundy. The fish – a sole – was cooked with a ")]), _c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("simplicity that I ignorantly thought of being defiantly English, but which was actually of the purest French. Situated as I was, near Mrs Fernie’s end of the table – we were, I think, sixteen – I found myself envying those at the other end where the Colonel presided and the frog laughed and Eddie displayed his naivety and charm. For Mrs Fernie kept things serious. Her conception of dinner-party conversation was lofty and old-fashioned. She had an elderly man with a goatee beard on her right, whom I identified to my own satisfaction as an Academician, and a very dark, very thin man with a pencil moustache on her left, who was laying down the law in precise terms about the relation of art to experience. It was not awfully exhilarating, and yet one couldn’t help but listen. He was making it clear that though France might be in dire straits politically and economically, the French nation had already resumed the cultural dictatorship that was its due. I was bored, but most awfully impressed. It seemed to me that this was the authentic voice of France that had been buried under failure, defeat and recrimination; and I could see that Mrs Fernie thought so too. She was indeed lapping it up, while at the same time, every now and then at least, she stuck in a delicate and even fragile oar of her own; her line was that, although she came from a nation that could only be considered barbarian by those fortunate enough to be French, she had nevertheless somehow escaped contagion, and even, by her own efforts and the gift of her serene intellect and fine sensibilities, contrived to aspire to be treated as an honorary Frenchwoman. The thin man declined to admit that such a being was possible – not of course in so many words, but by his terse dismissal of her proffered wares; while, from the depths of his vast civility, conceding that, if the unthinkable could indeed have been thought, then, in that case – "), _c('i', [_vm._v("mutatis mutandis")]), _vm._v(", as you, or rather he, might say – she would be wearing the white robe of a candidate.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("If my language seems mandarin – and absurd – it is because I am trying exactly to reflect my sensations.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("Their conversation was a little comedy, and these impressions of it which have remained with me could not have found just this verbal expression at the time. I was only conscious of the falsity of the conversation, and of its fundamental absurdity.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("I had however plenty of occasion to observe, for I had, despite my proclaimed mastery of the demotic, had no more success than Jamie in arousing the interest of the ladies on either side. To my left, a woman with short spiky grey hair had first resolutely tried to engage the Academician in talk – a task in which she failed ")]), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("because he was fretting to supplant the thin man and capture Mrs Fernie’s attention. While on my other side I had been landed with a very tall woman wearing a monocle who told me only that her father had been the ambassador of the Austro-Hungarian Emperor to France and that she bred and showed Arab horses, an activity which the war had seriously and unforgivably disturbed. There wasn’t much I could say to that. It would have been ridiculous to commiserate with her grievance; at the same time I didn’t see how, at Mrs Fernie’s table, at which the sole had been succeeded by duckling so tender and tasty that it seemed an insult deliberately levelled at the starving people of Europe – which thought I do remember as a measure of my boredom and disaffection – how, as I say, at Mrs Fernie’s table, I could have told her that her complaint disgusted me. So I sat silent, and ate the duckling, which despite my moment of priggish repulsion was so delicious as to disarm any criticism, and drank the claret which accompanied it, and listened with rather more than half an ear to the thin man telling Mrs Fernie that the novel was finished, superseded by criticism and the journal; fiction had become impossible because the artificiality of the construct was now inescapable; reality had rendered the imagination superfluous, just as psychology had made the whole Victorian concept of characterisation an activity suited only to moral imbeciles and mental defectives.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘But what is reality?’ Mrs Fernie advanced. Her eyes shone very blue, as Jamie’s did when he felt that he was not appreciated.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘It is because you can still ask such a question,’ the thin man flung his hand out, perilously close to the rim of his wine glass, ‘because you do not see that it is itself quite superfluous, …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘And yet,’ Mrs Fernie pursued, ‘we must surely have some framework within which …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘My dear lady,’ the thin man said, ‘all we have is experience. We are that, and nothing else. Our only knowledge is what happens to us, and what we feel …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("The lady on my left sighed, and abandoned her attempt on the Academician.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘I always think,’ she commanded my attention, ‘that there is something sad about a mixing of generations. I like the seasons to be distinct.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘In South Africa,’ I said, ‘where I have been living …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("‘But you live in England,’ she said, ‘you are a friend of Jamie’s at Cambridge.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("It was at that moment, more from a peculiar note of regret in ")]), _c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("her voice than from her accent, that I realised she was English herself; and it seemed to add to the absurdity of the evening that we should be engaged in French conversation, while a debate on the nature of reality went on around us. I asked her if she had lived long in France.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘Oh dear me yes,’ she said, in English. Then, reverting to the house rules, she returned to French and told me she was a sculptor who had come to Paris in the 1920s to study under a pupil of Rodin and remained here ever since.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘Even under the Occupation?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘There were difficulties, but yes.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘But they must have been enormous.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘Well,’ she said, ‘I had a brief marriage to a Frenchman. A mistake, but I was grateful. It meant I could get the right sort of papers. But yes, it was difficult, and yet, you know, what they are saying about experience being the only reality, well, we learned something of that. Do you know what I missed most during the Occupation: fish. It was impossible to get a sole or halibut. But you know people did the most surprising things, people really did surprise you, and that’s why Philippe there is quite right about character. Helena, you know – the lady on your other side’ – she lowered her voice – ‘she hates me to talk about it, and herself will speak of nothing now but her Arab horses, so that I could see, for I was listening with half an ear, that you thought her a tiresome and empty woman, she was a heroine of the Resistance, yes, a real heroine. Oh, I know’ – she leaned across me raising her voice – ‘that you don’t care for me to say so, but it’s quite true, you were a heroine.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("‘And you, Judith, are a tiresome gossip. It is over and done with.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("All this was embarrassing in a surprising fashion. We are of course usually wrong about other people. I knew that even then. All the same it is disconcerting when one’s errors are so quickly and publicly exposed. I saw I could only make things worse if I admitted that I had indeed dismissed Helena as tiresome and empty. And yet why shouldn’t I have done so? It was after all the impression that she sought to convey. I might have made things worse and added that I had been quite convinced that she was herself a Vichyiste, even a Fascist. So I muttered something and hoped the subject would pass away. I glanced across the table at Eddie, who, attracted by my attention, whisked up an eyebrow, before leaning over the table and addressing the yellowish frog ")]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("ment. I wondered when this appalling dinner-party would end, and thought with longing of escaping with him – and, yes, I supposed, Jamie too – on a round of the bars and night spots.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("There was a momentary silence: twenty to ten on the Louis Quinze ormolu clock, an angel was passing. Then from the void a harsh voice:")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Helena is quite right. Her Arab horses are a great deal more important than her experience in the Resistance.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("It was Jamie’s dark companion.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘How can you say such a thing?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Because the war was odious.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Oh, how glad I am to hear someone say that.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("It was Mrs Fernie who spoke, and for a moment the air seemed to hold those two voices, still and simultaneous, the one harsh and awkward, the double r of ‘"), _c('i', [_vm._v("guerre")]), _vm._v("’ rasped out, the other mellifluously low, and then the spell was broken.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘If only we could forget it,’ Mrs Fernie said, her Englishness exposed.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Oh, my dear, but that is of course absolutely impossible, I find that sentimental,’ the thin man, Philippe’s, hand again flashed over the rim of his wine glass. ‘We suffered of course, how we suffered is inconceivable for anyone with the innocence of islanders, we suffered treachery, which was worst of all.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘And some of us, Philippe, benefited,’ the dark woman said. ‘And we all know that what was destroyed in the war, in the Occupation, in the Resistance and in the "), _c('i', [_vm._v("épuration")]), _vm._v("’ – a word I must leave untranslated, because ‘purge’, which is its dictionary meaning, lacks the connotations with which history has now encrusted the French – ‘what … what was destroyed was a trust in human goodness.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Oh, but this is naive, my dear. I’m almost ashamed to listen to it. What after all is goodness?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Very well, Philippe,’ the woman lifted her glass and gestured to the butler, who proffered the bottle, but not before – I noticed – exchanging a quick glance with Mrs Fernie, whose nod seemed to suggest that the scene would be worse if he failed to comply with the woman’s request, ‘Very well, Philippe’ – she knocked back the claret as if it had been the roughest pinard, and she in a low bistro – ‘I don’t expect you to know. After all, we are what we experience, that’s right, isn’t it, and so doubtless we are not what we would prefer to forget. But I don’t forget that you were only a provincial schoolmaster back in ’37, and would probably have remained that and nothing more, if Lucien hadn’t seen a vestige ")]), _c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("of talent in a journal you submitted to him, and, with infinite care, brought it to some sort of birth. It was a thin thing even then in the end, but it offered you your escape and beginning …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘No, but this is …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Be quiet …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Monstrous …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘A good word. And he published my first poems too, or the first to be published, and encouraged us both. And everything you said, your whole tone of voice, was antipathetic to him, but he discerned talent. That was goodness. To put art above his own ideas of what was moral in ordinary life. Just as it was when … I never knew him other than good, a man of the highest and most generous sentiments, and now you trample on his reputation and spit on his memory and that is why I say war is odious.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Oh, but this is too ridiculous,’ he said; and if it wasn’t just that, we all felt that it was inappropriate. Mrs Fernie’s eyes were opened to her own maladroit social behaviour, and I saw a flicker of pleasure cross Jamie’s face at the revelation. Then she, who was engaged in a long war with her husband, turned to him in appeal, and he rose; putting his arm round the dark woman, he escorted her from the room, as he might on another occasion–and I saw he always would– lead a mourning widow or deprived daughter from a graveside. And the door closed behind them, white, with gold embossed.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘I am so sorry, Laura,’ said Philippe. ‘That was painful and ridiculous. I did warn you about poor Mathilde. Her talent has quite gone, you see, that is why she is now unbalanced. It is sad, but we have to accept it. And as for the man of whom she spoke, Lucien de Balafré, he was of no account. It is true he published my first things, but to say he helped me is otherwise absurd. We had nothing, I am pleased to say, in common. No, I assure you, a madwoman would now conjure with his name as Mathilde does …’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘I think you should know, Monsieur,’ Jamie’s careful diplomatic French sounded from the doorway, ‘that his son is my friend, and with us tonight. That’s right, Etienne,’ he said, in English, ‘your father was Lucien wasn’t he?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Yes, Monsieur,’ I said, ‘my father was certainly Lucien de Balafré.’")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("Eddie put his arm round me and squeezed.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘That was brave of Jamie,’ he said. ‘You know how he hates a scene. And he puked after, he really did. As for you, ducky, what you could do with is a stinger.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("He snapped his fingers at the waiter and instructed him in the proper proportions of brandy and "), _c('em', [_vm._v("crème de menthe")]), _vm._v(". Eddie’s French might be as lousy as he promised, but at this stage of life he could usually get what he wanted.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘And I think I’ll have one too, my dear,’ he said to the waiter.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Oh yes,’ I said, ‘I’m grateful to Jamie, it was brave of him. Sort of Jacobite. All the same I’d rather he hadn’t.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Jacobite?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Yes, a splendid and useless gesture.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("We were in a bar in Montmartre. Jamie had declined to come with us. The dinner-party had ended, not exactly in confusion, but in some embarrassment. Mrs Fernie, I felt, regarded me with disfavour and suspicion. I had been transformed from a harmless, possibly even helpful, friend of Jamie into a disagreeable object. The Sicilians have an admirable expression: ‘to swallow a toad’. It means to accept an unwelcome fact. I rather felt that I was a toad in Mrs Fernie’s gullet, and that it wasn’t at all certain that she could get it down. She hadn’t known anything about my father, and she was not the sort of person who could bear with equanimity the finding of herself at a disadvantage at her own table. It was in one sense as simple as that.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("But it was also much more, as indeed it was for me. We like, to put it at its simplest, to be judged for ourselves, as we would like, or think we would. Yet it never of course happens. Our reception is always coloured and distorted by associations, which we are – so often – powerless to protect ourselves against. I used, some twenty years ago, to be friendly with the widow of a famous poet, celebrated as much for his wild and self-destructive behaviour as for his verses. She was proud of him, and in memory had made their marriage perhaps into a finer thing than she had known at the time; and she was jealous to defend him. Yet at the same time she knew that she was diminished by it all too. People came to see her because of the man to whom she had been married. And it was a long time ago; in another country. All the recognition she got was a denial of her own reality. It was as if for so many people her own life had also ended in that New York hospital. Reflected fame subtracts from the identity of the person on whom the reflection falls.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("I couldn’t have elaborated this, as I sipped my stinger with Eddie and watched his eyes rove the little bar, but, looking back, these were the sentiments which disturbed me. And yet I was at the same time awfully curious.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘It’s not working for Jamie,’ Eddie said.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘What?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Our being here. It’s not working. He thought it would help, but it doesn’t.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Did he actually say so?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘He doesn’t have to. I think we should go.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Because of this evening?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Not just that.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘How do you know?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘I just do.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Well, I don’t understand. I don’t mind going. In fact, I would like to, and anyway, as you know, I have my other plans. All the same, why?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("Eddie picked up his glass.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘The compartments have got mixed,’ he said. ‘That gets on his nerves. He’s far more nervous and high-strung than you think.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘You know him better. You probably know him better than he knows himself.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Oh yes. Much better. So shall we?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘Yes,’ I said, and hesitated. ‘I’m going to my grandmother’s. In Provence. I haven’t seen her in … well, since I was a child, before the war. But you know that.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘It’s all right,’ Eddie said, ‘I’m not suggesting that I should come with you. Compartments are important. Nobody knows that better than me. But I think we should get out soon. If you’ve got a definite date to go there, we could drift about first. That might be fun.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘This evening,’ I said.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘You don’t have to talk about it. You don’t have to at all.’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘No,’ I said, ‘I don’t, do I?’")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘So now,’ he said, ‘let us resume the having of the fun. There’s a bar Toby told me about I want to take a look at …’")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("But we didn’t go off together, though not because of anything that happened that evening, which led us through a succession of bars till we came to one where Eddie disappeared upstairs with a mulatto sailor, while I sat drinking "), _c('em', [_vm._v("pinard")]), _vm._v(" with his dancing-partner and declining more and more laconically the repeated, but half-hearted, suggestions that perhaps we should go upstairs too. It wasn’t anything to do with that, and I was grateful to Eddie for his lack of curiosity or his self-restraint. But I wondered at my decision even as I boarded the train to the south, and sat back on the hard shiny green leather, and watched the suburbs of Paris slip by. Tears pricked my eyes, tears of loneliness and apprehension. ")]), _c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v(" Compartments are important. I had locked one door behind me, and I have often wondered since how different my life would have been if I had not done so.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("There were fewer suburbs then, and no high-rise apartment blocks on the fringe of the city. The train was soon passing through a miniature and scruffy landscape of canals and rivers, cottages crouching by the lines which were flanked with poplars under a heavy grey sky. It started to rain. The occasional clumsy lorry or chugging little car waited at level-crossings, a curé bicycling in his long cassock hung for a moment motionless on the hump of a bridge, a girl drove black-and-white cattle from a water-meadow. It was the landscape of the Impressionists, but diminished and meaner, with a suggestion of attenuation which is absent from their paintings. The rain streamed down the pale green willow that overhung the waters. I looked out of the window and avoided the gaze of my fellow-passengers, and when the call for dinner came made my way to the restaurant car.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2869bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674920_chapter_02.vue
// module id = 84
// module chunks = 0